"use client"
import NextImage from "next/image"
import CallToAction from "@/components/CallToAction"
import PhotoBean from "@/components/PhotoBean"
import getSBImageDimensions from "@/utilities/getSBImageDimensions";

import LinedCircle from "../../public/assets/lined-circle.svg"

export default function Hero({
  clientName,
  csmName,
  csmImageSrc,
  csmImageAlt,
  primaryHref = "#get-started",
  secondaryHref = "#need-help",
}) {
  return (
    <section id="" className="bg-blue-gradient text-white pt-10 lg:pt-20 pb-48 lg:pb-12 relative overflow-x-clip">
      <LinedCircle className="absolute w-64 lg:-top-5 lg:-right-11 -top-9 -right-24 fill-blue-dark" />

      <div className="flex flex-col lg:flex-row justify-between max-w-screen-xl 2xl:max-w-screen-2xl m-auto gap-4 relative z-10">
        {/* Text content */}
        <div className="container lg:w-1/2 relative z-0 flex flex-col gap-10 lg:justify-between mx-auto pb-5 lg:pb-0">
          <NextImage src="/assets/2060logo.svg" alt="logo" height="57" width="288"/>
          <div className="grid grid-cols-1 gap-5 lg:pb-10">
            <h1>
              Welcome to 2060,<br /> {clientName || "Client"}!
            </h1>

            <p className="uppercase text-h3 font-bold">
              Hi, I'm {`${csmName}, your Client Success Manager`}
            </p>

            <p>
              Every great partnership starts with collaboration, so we need access
              to a few things to get the ball rolling. I'm here to help you get started.
            </p>

            <div className="flex items-center gap-4">
              <CallToAction style="primary" href={primaryHref} >Get Started</CallToAction>
              <CallToAction style="secondary-dark" href={secondaryHref}>Need Help?</CallToAction>
            </div>
          </div>
        </div>
        <div className="flex flex-col lg:pr-6 2xl:pr-12 lg:w-1/2 absolute w-full top-full lg:relative z-50">
          {csmImageSrc ? (
            <PhotoBean
              src={csmImageSrc}
              alt={csmImageAlt || (csmName ? `Photo of ${csmName}` : "CSM")}
              height={getSBImageDimensions("height", csmImageSrc)}
              width={getSBImageDimensions("width", csmImageSrc)}  
            />
          ) : (
            <div>CSM Photo</div>
          )}
        </div>
      </div>
    </section>
  );
}
